import { Icon, IconProps } from '@chakra-ui/react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { Tooltip } from './ui/tooltip';

export const TooltipIcon = ({ content, ...props }: { content: string; inverted?: boolean } & IconProps) => {
  return (
    <Tooltip content={content} openDelay={100} closeDelay={100}>
      <Icon color="fg.subtle" boxSize={4} {...props}>
        <HiOutlineInformationCircle />
      </Icon>
    </Tooltip>
  );
};
